export const WEBSHOP_SELECT_ITEM =   'WEBSHOP_SELECT_ITEM';
export const WEBSHOP_SELECT_ITEM_RESET =   'WEBSHOP_SELECT_ITEM_RESET';